import mediatorChannels from "@tvg/mediator";
import { BetaFeature } from "@tvg/sh-lib-beta-program/types";
import { GTM_BETA_PROGRAM } from "@tvg/sh-lib-beta-program/types/gtm";
// @ts-ignore
import pushToDataLayer from "../gtmUtils";

interface Payload<T> {
  payload: T;
}

interface ViewOnboardModal {
  betaFeature: BetaFeature;
}

interface ModalCTA {
  eventLabel: string;
}

interface AccountPanelNavigation extends ModalCTA {
  destinationUrl: string;
}

interface ViewWelcomeModal {
  betaFeature: BetaFeature;
}

export default () => {
  mediatorChannels.base.subscribe(
    GTM_BETA_PROGRAM.ONBOARDING_VIEW,
    ({ payload }: Payload<ViewOnboardModal>) => {
      const { betaFeature } = payload;
      pushToDataLayer({
        event: "betaOnboarding",
        gaEventCategory: "Beta Onboarding",
        gaEventAction: "Try Now Modal Viewed",
        gaEventLabel: betaFeature,
        module: betaFeature + " Try Now Modal"
      });
    }
  );

  mediatorChannels.base.subscribe(
    GTM_BETA_PROGRAM.ONBOARD_CTA,
    ({ payload }: Payload<ModalCTA>) => {
      const { eventLabel } = payload;
      pushToDataLayer({
        event: "betaOnboarding",
        gaEventCategory: "Beta Onboarding",
        gaEventAction: "CTA Clicked",
        gaEventLabel: eventLabel,
        module: "Program Page Try Now Modal"
      });
    }
  );

  mediatorChannels.base.subscribe(GTM_BETA_PROGRAM.EXIT_VIEW, () => {
    pushToDataLayer({
      event: "betaOnboarding",
      gaEventCategory: "Beta Onboarding",
      gaEventAction: "Exit Modal Viewed",
      gaEventLabel: "Program Page",
      module: "Program Page Exit Modal"
    });
  });

  mediatorChannels.base.subscribe(
    GTM_BETA_PROGRAM.EXIT_CTA,
    ({ payload }: Payload<ModalCTA>) => {
      const { eventLabel } = payload;
      pushToDataLayer({
        event: "betaOnboarding",
        gaEventCategory: "Beta Onboarding",
        gaEventAction: "CTA Clicked",
        gaEventLabel: eventLabel,
        module: "Program Page Exit Modal"
      });
    }
  );

  mediatorChannels.base.subscribe(GTM_BETA_PROGRAM.LEARN_MORE_VIEW, () => {
    pushToDataLayer({
      event: "betaOnboarding",
      gaEventCategory: "Beta Onboarding",
      gaEventAction: "Whats New Modal Viewed",
      gaEventLabel: "Program Page",
      module: "Program Page Whats New Modal"
    });
  });

  mediatorChannels.base.subscribe(
    GTM_BETA_PROGRAM.LEARN_MORE_CTA,
    ({ payload }: Payload<ModalCTA>) => {
      const { eventLabel } = payload;
      pushToDataLayer({
        event: "betaOnboarding",
        gaEventCategory: "Beta Onboarding",
        gaEventAction: "CTA Clicked",
        gaEventLabel: eventLabel,
        module: "Program Page Whats New Modal"
      });
    }
  );

  mediatorChannels.base.subscribe(GTM_BETA_PROGRAM.FEEDBACK_OPEN, () => {
    pushToDataLayer({
      event: "betaOnboarding",
      gaEventCategory: "Beta Onboarding",
      gaEventAction: "Feedback Widget Opened",
      gaEventLabel: "Program Page",
      module: "Program Page Feedback Widget"
    });
  });

  mediatorChannels.base.subscribe(GTM_BETA_PROGRAM.FEEDBACK_SUBMIT, () => {
    pushToDataLayer({
      event: "betaOnboarding",
      gaEventCategory: "Beta Onboarding",
      gaEventAction: "Feedback Widget Submitted",
      gaEventLabel: "Program Page",
      module: "Program Page Feedback Widget"
    });
  });

  mediatorChannels.base.subscribe(
    GTM_BETA_PROGRAM.ACCOUNT_PANEL_LINK,
    ({ payload }: Payload<AccountPanelNavigation>) => {
      const { eventLabel, destinationUrl } = payload;
      pushToDataLayer({
        event: "navigation",
        gaEventCategory: "Navigation",
        gaEventAction: "Account Panel Link Clicked",
        gaEventLabel: eventLabel,
        module: "Account Panel",
        destinationUrl,
        tag: undefined,
        menu: undefined
      });
    }
  );

  mediatorChannels.base.subscribe(
    GTM_BETA_PROGRAM.WELCOME_VIEW,
    ({ payload }: Payload<ViewWelcomeModal>) => {
      const { betaFeature } = payload;
      pushToDataLayer({
        event: "betaOnboarding",
        gaEventCategory: "Beta Onboarding",
        gaEventAction: "Welcome Modal Viewed",
        gaEventLabel: betaFeature,
        module: "Program Page Welcome Modal"
      });
    }
  );

  mediatorChannels.base.subscribe(GTM_BETA_PROGRAM.LETS_START_CTA, () => {
    pushToDataLayer({
      event: "betaOnboarding",
      gaEventCategory: "Beta Onboarding",
      gaEventAction: "CTA Clicked",
      gaEventLabel: "Let's Start",
      module: "Program Page Welcome Modal"
    });
  });
};
